import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const createCustomerService = async (values, isGroupCustomer) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const payload = { ...values, isGroupCustomer };
    const response = await axios.post(
      `${API_URL}/customer/create-customer`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};
export const updateCustomerService = async (values, isGroupCustomer, id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const payload = { ...values, isGroupCustomer };
    const response = await axios.put(
      `${API_URL}/customer/update-customer/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};
export const createPigmyCustomerService = async (values) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/customer/create-pigmy-customer`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};
export const getAllCustomerService = async (
  page,
  rowsPerPage,
  isGroupCustomer,
  filter
) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/customer/get-all-customers`, {
      params: { page: page + 1, limit: rowsPerPage, isGroupCustomer, filter },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};

export const searchCustomerService = async (
  page,
  rowsPerPage,
  searchQuery,
  isGroupCustomer,
  filter
) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/customer/find-customer`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        search: searchQuery,
        isGroupCustomer,
        filter,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};
export const getCustomerByIdService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/customer/get-customer-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch customer. Please try again."
    );
  }
};

export const fetchEnquiresService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  status
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/customer/get-enquires`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        limit: rowsPerPage,
        status,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
